import { render, staticRenderFns } from "./QuickEntrySection.vue?vue&type=template&id=35bbcd51&scoped=true"
import script from "./QuickEntrySection.vue?vue&type=script&lang=js"
export * from "./QuickEntrySection.vue?vue&type=script&lang=js"
import style0 from "./QuickEntrySection.vue?vue&type=style&index=0&id=35bbcd51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bbcd51",
  null
  
)

export default component.exports